import * as amplitude from '@amplitude/analytics-browser'

const AMPLITUDE_KEY = import.meta.env.VITE_AMPLITUDE_KEY

export const configAmplitude = () => {
  if (!AMPLITUDE_KEY) return
  amplitude.init(AMPLITUDE_KEY, {
    defaultTracking: true,
  })
}

type AmplitudeActionName =
  | 'Select price'
  | 'Change price interval'
  | 'Select suggestion'
  | 'Select rephrase suggestion'
  | 'Dismiss rephrase suggestion'
  | 'Get new advanced suggestion'
  | 'Get new advanced suggestion for selection'
  | 'Rephrase info I want to know more'
  | 'Rephrase info close'
  | 'Rephrase I want to upgrade to premium'
  | 'Sign in Google'
  | 'Sign up Google'
  | 'Sign in Email'
  | 'Sign up Email'
  | 'Download Chrome - Banner'
  | 'Download Chrome - Modal WebApp'
  | 'Open Evaluation Report'

interface AmplitudeAction {
  name: AmplitudeActionName
  extra?: Record<string, string | number | undefined>
}

export const trackUserAction = (payload: AmplitudeAction) => {
  amplitude.track('User Action', payload)
}
